module.exports = __webpack_public_path__ + "static/img/eureka_icon_2.f3fbd7fc.png";